export type UserRole = 'super_admin' | 'admin' | 'user';

export interface AuthUser {
    id: string;
    email: string;
    full_name: string | null;
    role: UserRole;
    organization_id?: string;
    count_day_limit: number;
    count_month_limit: number;
    max_scan_product_day: number;
    max_scan_product_month: number;

    count_projects: number;
    is_form_completed: boolean;
    deleted: boolean;
    tech_problems: boolean;
    total_count: number;
}

export interface Organization {
    id: string;
    name?: string | null;
    full_name?: string | null;
}

export interface OrganizationLimits {
    reached: number;
    maxLimit: number;
}

export const userName = (user?: AuthUser | null): string =>
    user?.full_name?.trim() || user?.email || 'пользователь';

export const userInitials = (user?: AuthUser | null): string => {
    const source = user?.full_name?.trim();
    if (!source) return (user?.email?.[0] ?? '?').toUpperCase();

    const [surname, name] = source.split(/\s+/);
    return `${surname?.[0] ?? ''}${name?.[0] ?? ''}`.toUpperCase();
};